export default __webpack_public_path__ + "c6d3c229d5507000824853962ca52548.svg";